import appsettings from "@/store/app-settings";
import { axiosGet, axiosPost } from "@/store/api/axiosUtils.js";
import * as userData from "@/auth/localStorageUtils.js";

const getMasterByType = (type = 3) => {
  const data = {
    id: type,
  };
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/MasterData/GetMasterByType",
    data
  );
};

const getDepartment = (type = 1) => {
  const data = {
    type,
  };
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/MasterData/GetDepartment",
    data
  );
};

const getArea = () => {
  const data = {
    mode: "area",
  };
  return axiosGet(appsettings.digtalIdAPIUrl + "api/master", data);
};

const getAreaByProvince = (province) => {
  const data = {
    mode: "areabyprovince",
    value: province,
  };
  return axiosGet(appsettings.digtalIdAPIUrl + "api/master", data);
};

const getProvince = () => {
  const data = {
    mode: "province",
  };
  return axiosGet(appsettings.digtalIdAPIUrl + "api/master", data);
};

const getProvinceByArea = (area) => {
  const data = {
    mode: "provincebyarea",
    value: area,
  };
  return axiosGet(appsettings.digtalIdAPIUrl + "api/master", data);
};

const getDistrict = (provinceCode) => {
  const data = {
    mode: "district",
    value: provinceCode,
  };
  return axiosGet(appsettings.digtalIdAPIUrl + "api/master", data);
};

const getSubDistrict = (districtCode) => {
  const data = {
    mode: "subdistrict",
    value: districtCode,
  };
  return axiosGet(appsettings.digtalIdAPIUrl + "api/master", data);
};

const getSubDistrictAutoComplete = (text) => {
  const data = {
    text,
  };
  return axiosGet(
    appsettings.digtalIdAPIUrl +
      "api/AddressUtils/GetAllSubDistrictAutocomplete",
    data
  );
};

const getAddressBySubDistrictCode = (code) => {
  const data = {
    subDistrictName: code,
  };
  return axiosGet(
    appsettings.digtalIdAPIUrl + "api/AddressUtils/GetAddressBySubDistrictName",
    data
  );
};

const getCompanyAutocompleteName = (text) => {
  const data = {
    text,
  };
  return axiosGet(
    appsettings.digtalIdAPIUrl + "api/AddressUtils/GetCompanyAutocompleteName",
    data
  );
};

const getAddressByGetByLongDooMap = (lat, lon) => {
  const data = {
    lat,
    lon,
  };
  return axiosGet(
    appsettings.digtalIdAPIUrl + "api/AddressUtils/GetByLongDooMap",
    data
  );
};

const getOfficerInfos = (department_id) => {
  var url =
    appsettings.ocpbOpenAPI +
    "api/OfficerInfos/GetStored?department_id=" +
    department_id +
    "&per_page=999";
  return require("axios").get(url, {
    headers: {
      "App-Key": "FE4FC3BC-287F-400D-2770-08D7C4BA67BA",
      Password: "FE4FC3BC-287F-4E2D-2770-08D7C4BA67FF",
    },
  });
};

const getOfficerInfoAll = () => {
  var url =
    appsettings.ocpbOpenAPI +
    "api/OfficerInfos/GetStoredAll?" +
    "per_page=9999";
  return require("axios").get(url, {
    headers: {
      "App-Key": "FE4FC3BC-287F-400D-2770-08D7C4BA67BA",
      Password: "FE4FC3BC-287F-4E2D-2770-08D7C4BA67FF",
    },
  });
};

const TmMasterDelete = (id) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl +
      "api/MasterData/TmMasterDelete?id=" +
      id +
      "&userId=" +
      userData.userId()
  );
};

const TmMasterGetListByMasterTypeID = (id, params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/MasterData/TmMasterGetListByMasterTypeID?id=" +
      id,
    params
  );
};

const TmMasterGetByMasterId = (masterId) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl +
      "api/MasterData/TmMasterGetByMasterId?masterId=" +
      masterId
  );
};

const TmMasterUpdate = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/MasterData/TmMasterUpdate",
    params
  );
};

const TmMasterGetMultiSelectedByMasterId = (masterId) => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl +
      "api/MasterData/TmMasterGetMultiSelectedByMasterId?masterId=" +
      masterId
  );
};
const TmMasterMultiSelectedUpdate = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl +
      "api/MasterData/TmMasterMultiSelectedUpdate",
    params
  );
};

const getComplaintContactType = () => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/MasterData/GetContactType"
  );
};

const getDigitalIdContactType = () => {
  return axiosGet(appsettings.digtalIdAPIUrl + "api/master?mode=contacttype");
};

const getStatusGroup = (departmentId, complaintId, type = "Mediate") => {
  const params = {
    departmentId,
    complaintId,
    type,
  };

  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/MasterData/GetStatusGroup",
    params
  );
};

const getDepartmentType1Type2 = () => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Department/GetType1Type2"
  );
};

const getReportDepartment = (type = null) => {
  const data = {
    type,
  };
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/Department/GetReportDepartment",
    data
  );
};

const getClueContactType = () => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/MasterData/GetClueContactTypes"
  );
};

const getClueMasterByType = (type = 15) => {
  const data = {
    id: type,
  };
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/MasterData/GetClueMasterByTypes",
    data
  );
};

const getClueStatusFilter = () => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/MasterData/GetClueStatusFilter"
  );
};

const getCompanySla = () => {
  return axiosGet(appsettings.ocpbComplaintAPIUrl + "api/DigitalApi/companySla/list");
};


const GetWebexToken = () => {
  return axiosGet(
    appsettings.ocpbComplaintAPIUrl + "api/WebexToken/GetWebexToken" 
  );
};
const UpdateToken = (params) => {
  return axiosPost(
    appsettings.ocpbComplaintAPIUrl + "api/WebexToken/UpdateToken", 
    params
  );
};
export {
  getMasterByType,
  getDepartment,
  getArea,
  getAreaByProvince,
  getProvinceByArea,
  getProvince,
  getDistrict,
  getSubDistrict,
  getSubDistrictAutoComplete,
  getAddressBySubDistrictCode,
  getAddressByGetByLongDooMap,
  getOfficerInfos,
  getOfficerInfoAll,
  TmMasterDelete,
  TmMasterGetListByMasterTypeID,
  TmMasterGetByMasterId,
  TmMasterUpdate,
  TmMasterGetMultiSelectedByMasterId,
  TmMasterMultiSelectedUpdate,
  getDigitalIdContactType,
  getComplaintContactType,
  getStatusGroup,
  getDepartmentType1Type2,
  getReportDepartment,
  getCompanyAutocompleteName,
  getClueContactType,
  getClueMasterByType,
  getClueStatusFilter,
  GetWebexToken,
  UpdateToken,
  getCompanySla,
};
